module.exports = __webpack_public_path__ + "static/media/ssoSteps.9dddca8b.png";